export const get_Man_Data_Request = "get_Man_Data_Request"
export const get_Man_Data_Success = "get_Man_Data_Success"
export const get_Man_Data_Failure = "get_Man_Data_Failure" 

export const get_women_Data_Request = "get_women_Data_Request"
export const get_women_Data_Success = "get_women_Data_Success"
export const get_women_Data_Failure = "get_women_Data_Failure" 

export const get_kids_Data_Request = "get_kids_Data_Request"
export const get_kids_Data_Success = "get_kids_Data_Success"
export const get_kids_Data_Failure = "get_kids_Data_Failure" 

export const get_kitchen_Data_Request = "get_kitchen_Data_Request"
export const get_kitchen_Data_Success = "get_kitchen_Data_Success"
export const get_kitchen_Data_Failure = "get_kitchen_Data_Failure" 

export const get_Man_Single_Data_Request = "get_Man_Data_Single_Request"
export const get_Man_Single_Data_Success = "get_Man_Data_Single_Success"
export const get_Man_Single_Data_Failure = "get_Man_Data_Single_Failure" 

export const get_women_Single_Data_Request = "get_women_Single_Data_Request"
export const get_women_Single_Data_Success = "get_women_Single_Data_Success"
export const get_women_Single_Data_Failure = "get_women_Single_Data_Failure" 

export const get_kids_Single_Data_Request = "get_kids_Single_Data_Request"
export const get_kids_Single_Data_Success = "get_kids_Single_Data_Success"
export const get_kids_Single_Data_Failure = "get_kids_Single_Data_Failure" 

export const get_kitchen_Single_Data_Request = "get_kitchen_Single_Data_Request"
export const get_kitchen_Single_Data_Success = "get_kitchen_Single_Data_Success"
export const get_kitchen_Single_Data_Failure = "get_kitchen_Single_Data_Failure" 

export const get_Cart_Data_Request = "get_Cart__Data_Request"
export const get_Cart_Data_Success = "get_Cart__Data_Success"
export const get_Cart_Data_Failure = "get_Cart__Data_Failure" 

